import React, { useEffect, useState, useMemo } from "react";
import api from "../api/api";

import {
  Layout,
  Card,
  Typography,
  Button,
  Input,
  Modal,
  Form,
  Select,
  Row,
  Col,
  Tag,
  Space,
  Spin,
  Empty,
  Avatar,
  Popconfirm,
  message,
  Divider,
  Badge,
} from "antd";

import {
  SearchOutlined,
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  FileProtectOutlined,
  UserOutlined,
  SafetyCertificateOutlined,
} from "@ant-design/icons";
import { useAcademicYear } from "../AcademicYearContext";

import {
DownloadOutlined,
FilterOutlined,
} from "@ant-design/icons";


const { Title, Text } = Typography;
const { TextArea } = Input;



const ALLOWED_ROLES = [
  "admin",
  "teacher",
  "registry",
  "business manager",
  "vpi",
  "vpa",
  "dean",
];



const normalizeRole = (role) =>
  (role || "").trim().toLowerCase();



const getStoredUser = () => {

  const raw = localStorage.getItem("user");

  if (!raw) return null;

  try {

    return JSON.parse(raw);

  } catch {

    return null;

  }

};





const Complaint = () => {
  const {
        selectedYear,
        initialized
    } = useAcademicYear();


  const [userType,setUserType] = useState(null);
  const [students,setStudents] = useState([]);
  const [complaints,setComplaints] = useState([]);
  const [loading,setLoading] = useState(false);
  const [loadingStudents,setLoadingStudents] = useState(false);

  const [periods,setPeriods] = useState([]);
  const [selectedPeriod,setSelectedPeriod] = useState(null);
  const [gradeClasses,setGradeClasses] = useState([]);
  const [selectedGradeClass,setSelectedGradeClass] = useState(null);
  const [chartLoading,setChartLoading] = useState(false);


  const [search,setSearch] = useState("");


  const [modalOpen,setModalOpen] = useState(false);


  const [editId,setEditId] = useState(null);


  const [selectedStudent,setSelectedStudent] = useState(null);


  const [form] = Form.useForm();


const fetchPeriods = async()=>{

    try{

        const res = await api.get(
            "/api/users/periods/"
        );


        const data = Array.isArray(res.data)
        ? res.data
        : res.data?.results || [];


        setPeriods(data);


    }catch(error){

        message.error(
            "Unable to load periods"
        );

    }

};

const fetchGradeClasses = async()=>{

    try{

        const res = await api.get(
            "/api/grade-classes/"
        );


        const data = Array.isArray(res.data)
        ? res.data
        : res.data?.results || [];


        setGradeClasses(data);


    }catch(error){

        message.error(
            "Unable to load grade classes"
        );

    }

};



  useEffect(()=>{


    const user = getStoredUser();


    if(user){

      setUserType(
        normalizeRole(
          user.user_type || user.role
        )
      );

    }


  },[]);







  const canPost = useMemo(()=>{


    return ALLOWED_ROLES.includes(
      normalizeRole(userType)
    );


  },[userType]);







const fetchStudents = async () => {
    if (!selectedYear?.id) {
        setStudents([]);
        return;
    }

    try {
        setLoadingStudents(true);

        const res = await api.get(
            "/api/users/students/",
            {
                params: {
                    academic_year: selectedYear.id
                }
            }
          );

        const data = Array.isArray(res.data)
            ? res.data
            : res.data?.results || [];

        setStudents(data);
    } catch (error) {
        message.error("Unable to load students");
    } finally {
        setLoadingStudents(false);
    }
};


  // const fetchComplaints = async()=>{


  //   try{


  //     setLoading(true);


  //     const res = await api.get(
  //       "/complaints/"
  //     );


  //     setComplaints(

  //       Array.isArray(res.data)
  //       ? res.data
  //       : res.data.results || []

  //     );


  //   }catch(error){


  //     message.error(
  //       "Unable to load complaints"
  //     );


  //   }finally{

  //     setLoading(false);

  //   }


  // };




const fetchComplaints = async () => {
    if (!selectedYear?.id) {
        setComplaints([]);
        return;
    }

    try {
        setLoading(true);

        const res = await api.get(
            "/complaints/",
            {
                params: {
                    academic_year: selectedYear.id
                }
            }
        );

        const data = Array.isArray(res.data)
            ? res.data
            : res.data?.results || [];

        setComplaints(data);
    } catch (error) {
        message.error("Unable to load complaints");
    } finally {
        setLoading(false);
    }
};



  // useEffect(()=>{


  //   if(userType){

  //     fetchComplaints();

  //     if(canPost){

  //       fetchStudents();

  //     }

  //   }


  // },[userType]);



useEffect(() => {
    if (
        !userType ||
        !initialized ||
        !selectedYear?.id
    ) {
        return;
    }

    fetchComplaints();

    // if (canPost) {
    //     fetchStudents();
    // }
    if (canPost) {

    fetchStudents();

    fetchPeriods();

}


if (
    normalizeRole(userType) !== "teacher"
){

    fetchGradeClasses();

    fetchPeriods();

}
}, [
    userType,
    canPost,
    selectedYear?.id,
    initialized
]);





  // const filteredComplaints = complaints.filter(item=>{


  //   const q = search.toLowerCase();


  //   return (

  //     item.title?.toLowerCase()
  //     .includes(q)

  //     ||

  //     item.student_full_name
  //     ?.toLowerCase()
  //     .includes(q)

  //   );


  // });

  const filteredComplaints = complaints.filter(item=>{


const q = search.toLowerCase();


return (

item.title?.toLowerCase()
.includes(q)

||

item.student_full_name
?.toLowerCase()
.includes(q)

)

&&

(
!selectedPeriod
||
item.period === selectedPeriod
)

&&

(
!selectedGradeClass
||
item.grade_class === selectedGradeClass
);


});









  const openCreate = ()=>{


    setEditId(null);

    setSelectedStudent(null);

    form.resetFields();

    setModalOpen(true);


  };








  const openEdit=(item)=>{


    setEditId(item.id);


    setSelectedStudent({

      id:item.student,

      full_name:item.student_full_name

    });


    form.setFieldsValue({

      title:item.title,

      description:item.description

    });


    setModalOpen(true);


  };









  const submitComplaint = async(values)=>{


    if(!selectedStudent){

      message.warning(
        "Select a student first"
      );

      return;

    }

    if(!values.period){

    message.warning(
        "Please select complaint period"
    );

    return;

}


    // const payload={

    //   student:selectedStudent.id,

    //   title:values.title,

    //   description:values.description

    // };

    const payload={

    student:selectedStudent.id,

    period:values.period,

    title:values.title,

    description:values.description

};




    try{


      if(editId){


        const res = await api.patch(

          `/complaints/${editId}/`,

          payload

        );


        setComplaints(prev=>

          prev.map(c=>

            c.id===editId

            ? res.data

            : c

          )

        );


        message.success(
          "Complaint updated"
        );


      }else{


        const res = await api.post(

          "/complaints/",

          payload

        );


        setComplaints(prev=>[

          res.data,

          ...prev

        ]);


        message.success(
          "Complaint submitted"
        );


      }


      setModalOpen(false);

      form.resetFields();

      setEditId(null);



    }catch(error){


      message.error(
        "Failed to submit complaint"
      );


    }


  };









  const deleteComplaint = async(id)=>{


    try{


      await api.delete(

        `/complaints/${id}/`

      );


      setComplaints(prev=>

        prev.filter(
          c=>c.id!==id
        )

      );


      message.success(
        "Complaint removed"
      );


    }catch(error){


      message.error(
        "Delete failed"
      );


    }


  };








  if(!canPost){


    return (

      <Card>

        <Typography.Text type="danger">

          You do not have permission to access complaints.

        </Typography.Text>

      </Card>

    );


  }








  return (


    <Layout

      style={{

        background:"#e5e7eb",

        minHeight:"100%",

        padding:20

      }}

    >


      <Card

        style={{

          maxWidth:1400,

          width:"100%",

          margin:"auto",

          background:"#111827",

          borderRadius:20

        }}

      >



        <Space

          direction="vertical"

          style={{width:"100%"}}

        >


<Title
    level={2}
    style={{
        color: "#ffffff",
        textAlign: "center"
    }}
>
    <SafetyCertificateOutlined />
    {" "}
    School Complaint Investigation Unit
</Title>

<Text
    style={{
        color: "#d1d5db",
        display: "block",
        textAlign: "center"
    }}
>
    Student complaint monitoring and administrative review system
</Text>

{selectedYear && (
    <div
        style={{
            textAlign: "center",
            marginTop: 12
        }}
    >
<Tag
    color="volcano"
    style={{
        fontSize: 15,
        fontWeight: "bold",
        padding: "6px 14px"
    }}
>
            Academic Year:
            {" "}
            {selectedYear.name}
        </Tag>
    </div>


)}





        </Space>




      </Card>









      <Card

        style={{

          marginTop:20,

          borderRadius:18

        }}

      >



        <Row

          justify="space-between"

          gutter={[16,16]}

        >



          <Col xs={24} md={16}>


            <Input

              size="large"

              placeholder="Search complaint records..."

              prefix={<SearchOutlined />}

              value={search}

              onChange={e=>setSearch(e.target.value)}

            />


          </Col>


          {
normalizeRole(userType)!=="teacher"
&&
(

<Card

style={{

marginTop:20,

borderRadius:18

}}

>

<Row gutter={[16,16]}>


<Col xs={24} md={8}>

<Select

allowClear

placeholder="Filter Grade Class"

style={{

width:"100%"

}}

value={selectedGradeClass}

onChange={setSelectedGradeClass}

options={gradeClasses.map(item=>({

value:item.id,

label:item.name

}))}

/>

</Col>



<Col xs={24} md={8}>

<Select

allowClear

placeholder="Filter Period"

style={{

width:"100%"

}}

value={selectedPeriod}

onChange={setSelectedPeriod}

options={periods.map(item=>({

value:item.id,

label:item.name

}))}

/>

</Col>



<Col xs={24} md={8}>


</Col>


</Row>


</Card>

)
}







          <Col xs={24} md={8}>


            <Button

              block

              size="large"

              type="primary"

              icon={<PlusOutlined />}

              onClick={openCreate}

              style={{

                background:"#6b0f1a",

                borderColor:"#6b0f1a"

              }}

            >

              New Complaint

            </Button>


          </Col>



        </Row>


      </Card>









      <Divider />









      {

        loading

        ?

        <Spin />

        :

        filteredComplaints.length===0

        ?

        <Empty />

        :



        <Row gutter={[20,20]}>


        {

          filteredComplaints.map(item=>(


            <Col

              xs={24}

              sm={12}

              lg={8}

              key={item.id}

            >


              <Card

                hoverable

                style={{

                  borderRadius:18,

                  borderTop:"5px solid #6b0f1a"

                }}

              >


                <Space>

                  <Avatar

                    size={45}

                    icon={<UserOutlined />}

                    style={{

                      background:"#111827"

                    }}

                  />


                  <div>

                    <Text strong>

                      {item.student_full_name}

                    </Text>


                    <br/>


                    <Badge

                      status="processing"

                      text="Under Review"

                    />

                    <br/>


<Tag
    color="blue"
    style={{
        marginTop:8,
        fontWeight:"600"
    }}
>
    Period: {
        item.period_name || "Not Assigned"
    }
</Tag>

                  </div>


                </Space>




                <Divider />



                <Title level={5}>

                  <FileProtectOutlined />

                  {" "}{item.title}

                </Title>




                <Text>

                  {item.description}

                </Text>





                <Divider />



                <Tag color="red">

                  Official Complaint

                </Tag>




                <Space

                  style={{

                    marginTop:15

                  }}

                >



                  <Button

                    icon={<EditOutlined />}

                    onClick={()=>openEdit(item)}

                  />



                  <Popconfirm

                    title="Delete complaint?"

                    onConfirm={()=>deleteComplaint(item.id)}

                  >

                    <Button

                      danger

                      icon={<DeleteOutlined />}

                    />

                  </Popconfirm>



                </Space>



              </Card>


            </Col>


          ))

        }


        </Row>


      }









      <Modal

        open={modalOpen}

        title={

          editId

          ?

          "Update Complaint"

          :

          "Create Complaint"

        }

        onCancel={()=>setModalOpen(false)}

        footer={null}

      >



        <Form

          form={form}

          layout="vertical"

          onFinish={submitComplaint}

        >



          <Form.Item label="Student">


            <Select

              showSearch

              loading={loadingStudents}

              value={selectedStudent?.id}

              onChange={(id)=>{

                const student =
                students.find(
                  s=>s.id===id
                );

                setSelectedStudent(student);

              }}

              options={students.map(s=>({

                value:s.id,

                label:s.full_name

              }))}

            />


          </Form.Item>


<Form.Item

    name="period"

    label="Complaint Period"

    rules={[
        {
            required:true,
            message:"Select complaint period"
        }
    ]}

>


<Select

    placeholder="Select period"

    options={periods.map(period=>({

        value:period.id,

        label:period.name

    }))}

/>


</Form.Item>



          <Form.Item

            name="title"

            label="Complaint Title"

            rules={[

              {

                required:true

              }

            ]}

          >

            <Input />

          </Form.Item>





          <Form.Item

            name="description"

            label="Description"

            rules={[

              {

                required:true

              }

            ]}

          >

            <TextArea rows={5}/>

          </Form.Item>




          <Button

            block

            type="primary"

            htmlType="submit"

            style={{

              background:"#6b0f1a",

              borderColor:"#6b0f1a"

            }}

          >

            Submit Complaint

          </Button>



        </Form>


      </Modal>






    </Layout>


  );


};


export default Complaint;

